import { styled } from "../../../../styles";

export const ModalContainer = styled("div", {
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  padding: "28px 42px",

  "@sm": {
    width: "100%",
    justifyContent: "center",
    padding: "0",
  },
});

export const Title = styled("p", {
  color: "$black",
  fontFamily: "$openSans",
  fontSize: "16px",
  lineHeight: "22px",
  fontWeight: "500",

  marginBottom: "12px",
});

export const Description = styled("p", {
  width: "100%",
  marginBottom: "20px",

  fontSize: 16,
  fontFamily: "$openSans",
  fontWeight: "400",
  lineHeight: "24px",
  color: "$charcoal",
});

export const FieldContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "6px",
});

export const FieldLabel = styled("label", {
  color: "$charcoal",
  fontFamily: "$openSans",
  fontSize: "14px",
  fontWeight: "600",
  lineHeight: "20px",
});

export const ErrorText = styled("p", {
  width: "100%",
  marginTop: "12px",

  color: "$error-dark",
  fontFamily: "$openSans",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "20px",
});

export const SubmitContainer = styled("div", {
  display: "flex",
  gap: "16px",
  padding: "28px 0 0 0",
  alignItems: "center",
});

export const CancelButton = styled("button", {
  height: "$13",
  padding: "0 $13",

  borderRadius: "20px",
  border: "2px solid $white",

  backgroundColor: "$white",

  gap: "$4",

  display: "flex",
  alignItems: "center",

  color: "$black",
  fontWeight: 600,
  lineHeight: "22px",
  fontSize: "$text-lg",
  fontFamily: "$openSans",

  cursor: "pointer",

  "&:focus": {
    outline: "none",
    border: "2px solid $primary-30",
  },
});
